module.exports = __webpack_public_path__ + "img/partners.597fab8e.svg";